// extracted by mini-css-extract-plugin
export default {"container":"CancellationFeedback_container__TnnOL","containerInner":"CancellationFeedback_containerInner__ATKJh"};